/* Refillia: chat in basso a destra con "Trova il tuo equivalente", WhatsApp e avvisi */
(function () {
  var box = document.querySelector('[data-rfch]');
  if (!box || box.dataset.rfchPronta) return;
  box.dataset.rfchPronta = '1';

  function $(s) { return box.querySelector(s); }
  var pan = $('[data-rfch-pannello]'), corpo = $('[data-rfch-corpo]'), piede = $('[data-rfch-piede]'), q = $('[data-rfch-q]');
  var lancia = $('[data-rfch-lancia]'), indietro = $('[data-rfch-indietro]');
  var titolo = $('[data-rfch-titolo]'), sotto = $('[data-rfch-sotto]');
  var titolo0 = titolo.textContent, sotto0 = sotto.textContent;
  var WA = box.dataset.wa, ICONA_WA = $('[data-rfch-icona-wa]').innerHTML;
  var ESEMPI = (box.dataset.esempi || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  var avvisi = [];
  try { avvisi = JSON.parse($('[data-rfch-avvisi]').textContent); } catch (e) {}

  /* elenco degli equivalenti: si carica una volta sola, quando serve */
  var dati = null, richiesta = null;
  window.RF_EQUIVALENTI = function () {
    if (dati) return Promise.resolve(dati);
    if (!richiesta) {
      richiesta = fetch(box.dataset.eqUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var m = t.match(/<script[^>]*data-rf-eq[^>]*>([\s\S]*?)<\/script>/);
          dati = m ? JSON.parse(m[1]) : [];
          return dati;
        })
        .catch(function () { richiesta = null; return []; });
    }
    return richiesta;
  };
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]/g, ' '); }
  window.RF_CERCA_EQ = function (lista, testo) {
    var parole = norm(testo).split(/\s+/).filter(function (w) { return w.length > 1; });
    if (!parole.length) return [];
    return lista.filter(function (p) {
      var t = norm(p.o + ' ' + p.m + ' ' + p.n);
      return parole.every(function (w) { return t.indexOf(w) >= 0; });
    }).map(function (p) {
      var o = norm(p.o).trim(), qq = norm(testo).trim(), punti = 0;
      if (o === qq) punti += 4; else if (o.indexOf(qq) === 0) punti += 2;
      if (norm(p.n).trim() === qq) punti += 3;
      if (p.u) punti += 1;
      return { p: p, v: punti };
    }).sort(function (a, b) { return b.v - a.v; }).map(function (x) { return x.p; });
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function waLink(t) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(t); }
  function giu() { corpo.scrollTop = corpo.scrollHeight; }
  function metti(html) { corpo.insertAdjacentHTML('beforeend', html); giu(); return corpo.lastElementChild; }
  function bot(html, poi) {
    var w = metti('<div class="rfch__msg rfch__msg--bot rfch__scrive" aria-hidden="true"><i></i><i></i><i></i></div>');
    setTimeout(function () { w.remove(); metti('<div class="rfch__msg rfch__msg--bot">' + html + '</div>'); if (poi) poi(); }, 600);
  }
  function io(t) { var d = document.createElement('div'); d.className = 'rfch__msg rfch__msg--io'; d.textContent = t; corpo.appendChild(d); giu(); }

  function home() {
    titolo.textContent = titolo0; sotto.textContent = sotto0;
    indietro.hidden = true; piede.hidden = true;
    corpo.innerHTML = $('[data-rfch-home]').innerHTML;
    corpo.querySelector('[data-rfch-vai="eq"]').addEventListener('click', function () { equivalente(); });
  }
  function altroBtn(riga) {
    var b = riga.querySelector('[data-altro]');
    if (b) b.addEventListener('click', function () { riga.remove(); bot('Dimmi pure un altro nome o una marca.'); q.focus(); });
  }
  function equivalente(cerca0) {
    titolo.textContent = 'Il tuo equivalente';
    sotto.textContent = 'I profumi famosi e i nostri, da 8,90 €';
    indietro.hidden = false; piede.hidden = false; corpo.innerHTML = '';
    window.RF_EQUIVALENTI();
    bot('Ciao! Che profumo usi di solito? Scrivi il <b>nome</b> o la <b>marca</b>, per esempio Sauvage o Chanel.', function () {
      if (cerca0) { cerca(cerca0); return; }
      if (ESEMPI.length) {
        var r = metti('<div class="rfch__rapide" data-esempi>' + ESEMPI.map(function (x) { return '<button type="button">' + esc(x) + '</button>'; }).join('') + '</div>');
        r.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { r.remove(); cerca(b.textContent); }); });
      }
      if (window.matchMedia('(min-width: 750px)').matches) q.focus();
    });
  }
  function cerca(testo) {
    io(testo);
    window.RF_EQUIVALENTI().then(function (lista) {
      var trovati = window.RF_CERCA_EQ(lista, testo);
      if (!trovati.length) {
        bot('Questo non lo troviamo tra i nostri equivalenti. Scrivici su WhatsApp: ti diciamo noi il profumo più vicino.', function () {
          altroBtn(metti('<div class="rfch__rapide"><a class="rfch__wa" href="' + esc(waLink('Ciao Refillia, cerco l’equivalente di ' + testo)) + '" target="_blank" rel="noopener">' + ICONA_WA + 'Chiedi su WhatsApp</a><button type="button" data-altro>Cerca un altro</button></div>'));
        });
        return;
      }
      var t0 = trovati[0];
      var intro = trovati.length === 1
        ? 'Il nostro equivalente di <b>' + esc(t0.o) + '</b> di ' + esc(t0.m) + ' è <b>' + esc(t0.n) + '</b>.'
        : 'Ne abbiamo <b>' + trovati.length + '</b>: ecco i nostri equivalenti.';
      bot(intro, function () {
        metti('<div class="rfch__res">' + trovati.slice(0, 10).map(function (t) {
          var foto = '<span class="rfch__foto">' + (t.i ? '<img src="' + esc(t.i) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>';
          var testo2 = '<span class="rfch__res-t"><small>Se ami ' + esc(t.o) + ' · ' + esc(t.m) + '</small><b>' + esc(t.n) + '</b>' + (t.u ? '<em>da ' + esc(t.p) + '</em>' : '') + '</span>';
          return t.u
            ? '<a href="' + esc(t.u) + '">' + foto + testo2 + '<span class="rfch__vai">Vedi</span></a>'
            : '<div>' + foto + testo2 + '<span class="rfch__arrivo">In arrivo</span></div>';
        }).join('') + '</div>');
        altroBtn(metti('<div class="rfch__rapide"><button type="button" data-altro>Cerca un altro</button><a class="rfch__wa" href="' + esc(waLink('Ciao Refillia, vorrei un consiglio sull’equivalente di ' + testo)) + '" target="_blank" rel="noopener">' + ICONA_WA + 'Chiedi un consiglio</a></div>'));
      });
    });
  }
  piede.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = q.value.trim();
    if (v.length < 2) return;
    q.value = '';
    var r = corpo.querySelector('[data-esempi]');
    if (r) r.remove();
    cerca(v);
  });
  indietro.addEventListener('click', home);

  function apri(vista) {
    box.classList.add('aperta', 'vista');
    lancia.setAttribute('aria-expanded', 'true');
    lancia.setAttribute('aria-label', 'Chiudi la chat');
    pan.setAttribute('aria-hidden', 'false');
    nascondi();
    if (vista && vista.indexOf('eq') === 0) equivalente(vista.split(':')[1]);
    else if (vista === 'wa' || !corpo.children.length) home();
    try { sessionStorage.setItem('rfch-vista', '1'); } catch (e) {}
  }
  function chiudi() {
    box.classList.remove('aperta');
    lancia.setAttribute('aria-expanded', 'false');
    lancia.setAttribute('aria-label', 'Apri la chat');
    pan.setAttribute('aria-hidden', 'true');
  }
  lancia.addEventListener('click', function () { box.classList.contains('aperta') ? chiudi() : apri(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('aperta')) { chiudi(); lancia.focus(); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rf-apri-chat]');
    if (a) { e.preventDefault(); apri(a.getAttribute('data-rf-apri-chat') || 'eq'); }
  });
  try { if (sessionStorage.getItem('rfch-vista')) box.classList.add('vista'); } catch (e) {}

  /* avvisi: ogni tanto uno, mai con la chat aperta; chiusi due volte non tornano */
  var av = $('[data-rfch-avviso]'), avImg = $('[data-rfch-avviso-img]');
  var i = 0, attuale = null, timer = null, chiusi = 0;
  try { chiusi = parseInt(sessionStorage.getItem('rfch-chiusi') || '0', 10) || 0; i = parseInt(sessionStorage.getItem('rfch-i') || '0', 10) || 0; } catch (e) {}
  function nascondi() { av.classList.remove('su'); clearTimeout(timer); }
  function mostra() {
    if (!avvisi.length || chiusi >= 2 || box.classList.contains('aperta') || document.hidden) return;
    attuale = avvisi[i % avvisi.length];
    i++;
    try { sessionStorage.setItem('rfch-i', String(i)); } catch (e) {}
    $('[data-rfch-avviso-t]').textContent = attuale.t;
    $('[data-rfch-avviso-s]').textContent = attuale.s;
    if (attuale.i) { avImg.src = attuale.i; avImg.hidden = false; } else { avImg.hidden = true; }
    av.classList.add('su');
    clearTimeout(timer);
    timer = setTimeout(nascondi, 8000);
  }
  $('[data-rfch-avviso-apri]').addEventListener('click', function () { apri(attuale ? attuale.v : 'eq'); });
  $('[data-rfch-avviso-x]').addEventListener('click', function () {
    chiusi++;
    try { sessionStorage.setItem('rfch-chiusi', String(chiusi)); } catch (e) {}
    nascondi();
  });
  /* bollino Google: compare dopo un attimo, si chiude per la sessione */
  var g = document.querySelector('[data-rfch-g]');
  if (g) {
    var gChiuso = false;
    try { gChiuso = sessionStorage.getItem('rfcBollino') === '0'; } catch (e) {}
    if (!gChiuso) setTimeout(function () { g.hidden = false; }, 1800);
    g.querySelector('[data-rfch-g-x]').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      g.hidden = true;
      try { sessionStorage.setItem('rfcBollino', '0'); } catch (e2) {}
    });
  }

  window.RF_ASSISTENTE = { apri: apri, chiudi: chiudi, avviso: mostra };
  var primo = (parseInt(box.dataset.primo, 10) || 8) * 1000, ogni = (parseInt(box.dataset.ogni, 10) || 45) * 1000;
  setTimeout(function () { mostra(); setInterval(mostra, ogni); }, primo);
})();
